<template>
  <div>
    <header-bar>マイリリース</header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="my-release-search-wrap">
          <div class="my-release-search-text">リリース検索</div>
          <form @submit.prevent="onClickedSearch">
            <input
              v-model="preKeyword"
              class="my-release-search"
              type="search">
          </form>
          <a
            class="c-btn c-btn--search"
            @click.prevent="onClickedSearch">
            <img
              src="/img/common/icon-search.png"
              alt="">検索
          </a>
        </div>
      </div>
    </div>

    <div
      ref="draftBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">作成中</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <release-table
            ref="draftTable"
            :release-status="draftReleaseStatuses"
            :keyword="keyword"
            @on-pagination-clicked="scrollTo('draftBlock')">
            <template v-slot:control1="slotProps">
              <div
                class="c-btn--edit2"
                @click.prevent="onEditReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template v-slot:control2="slotProps">
              <div
                class="c-btn--delete"
                @click.prevent="onDeleteReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>作成中のリリースはありません。
            </template>
          </release-table>
        </div>
      </div>
    </div>

    <div
      ref="rejectBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">審査差し戻し</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <release-table
            ref="rejectTable"
            :release-status="rejectedReleaseStatuses"
            :keyword="keyword"
            @on-pagination-clicked="scrollTo('rejectBlock')">
            <template v-slot:control1="slotProps">
              <div
                class="c-btn--edit2"
                @click.prevent="onEditReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template v-slot:control2="slotProps">
              <div
                class="c-btn--delete"
                @click.prevent="onDeleteReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>審査差し戻しのリリースはありません。
            </template>
          </release-table>
        </div>
      </div>
    </div>

    <div
      ref="pendingBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">審査中</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <release-table
            ref="pendingTable"
            :release-status="pendingReleaseStatuses"
            :keyword="keyword"
            :hide-control2="true"
            @on-pagination-clicked="scrollTo('pendingBlock')">
            <template v-slot:control1="slotProps">
              <div
                class="c-btn--note"
                @click.prevent="onEditReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template #control2>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>審査中のリリースはありません。
            </template>
          </release-table>
        </div>
      </div>
    </div>

    <div
      ref="publishedBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">デリバリ済み</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <release-table
            ref="publishedTable"
            :release-status="publishedReleaseStatuses"
            :keyword="keyword"
            :hide-link-control1="true"
            :hide-link-control2="true"
            :hide-link-control3="true"
            @on-pagination-clicked="scrollTo('publishedBlock')">
            <template v-slot:linkControl1="slotProps">
              <div
                class="c-btn--note"
                @click.prevent="onEditReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template v-slot:linkControl2="slotProps">
              <div
                class="c-btn--note"
                @click.prevent="onEditLinkClicked(slotProps.release)">
              </div>
            </template>
            <template v-slot:linkControl3="slotProps">
              <div
                v-if="isProductLinkDataExists(slotProps.release)"
                class="c-btn--note"
                @click.prevent="onShowLinkClicked(slotProps.release)">
              </div>
              <div
                v-else
                class="c-btn--note-disabled">
              </div>
            </template>
            <template #control2>
              <div class="c-btn--delivery"></div>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>デリバリ済みのリリースはありません。
            </template>
          </release-table>
        </div>
      </div>
    </div>

    <div
      ref="unPublishedBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">配信停止中（配信停止申請中も含む）</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <release-table
            ref="unPublishedTable"
            :release-status="takedownReleaseStatuses"
            :keyword="keyword"
            :hide-control2="true"
            @on-pagination-clicked="scrollTo('unPublishedBlock')">
            <template v-slot:control1="slotProps">
              <div
                class="c-btn--note"
                @click.prevent="onEditReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>配信停止中のリリースはありません。
            </template>
          </release-table>
        </div>
      </div>
    </div>

    <div
      ref="deletedBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">却下</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <release-table
            ref="deletedTable"
            :release-status="deletedReleaseStatuses"
            :keyword="keyword"
            :hide-control2="true"
            @on-pagination-clicked="scrollTo('deletedBlock')">
            <template v-slot:control1="slotProps">
              <div
                class="c-btn--note"
                @click.prevent="onEditReleaseClicked(slotProps.release)">
              </div>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>却下のリリースはありません。
            </template>
          </release-table>
        </div>
      </div>
    </div>

    <confirm-dialog
      name="deleteRelease"
      :is-shown="deleteReleaseShown"
      title="マイリリースの削除"
      @closed="deleteReleaseShown = false"
      @default-clicked="onDefaultClicked"
      @cancel-clicked="deleteReleaseShown = false">
      <template #body>
        削除します。<br />
        よろしいですか？
      </template>
    </confirm-dialog>
  </div>
</template>

<script>

import {
  CMAP_RELEASE_STATUS_DRAFT,
  CMAP_RELEASE_STATUS_IN_REVIEW,
  CMAP_RELEASE_STATUS_REJECTED,
  CMAP_RELEASE_STATUS_UPLOADING,
  CMAP_RELEASE_STATUS_DSP_REJECTED,
  CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
  CMAP_RELEASE_STATUS_PUBLISHED,
  CMAP_RELEASE_STATUS_EDITING,
  CMAP_RELEASE_STATUS_REAPPLY,
  CMAP_RELEASE_STATUS_DSP_REAPPLY,
  CMAP_RELEASE_STATUS_APPEND_DSP,
  CMAP_RELEASE_STATUS_TAKE_DOWN,
  CMAP_RELEASE_STATUS_RELEASE_REJECTED,
  CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
  CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN,
  CMAP_RELEASE_STATUS_PREPARE_REJECTED,
  CMAP_RELEASE_STATUS_PREPARE_RELEASE_REJECTED,
  CMAP_RELEASE_STATUS_EDIT_UPLOADING,
} from '../../../consts/status'
import ConfirmDialog from '../../../components/ConfirmDialog'
import HeaderBar from '../HeaderBar'
import ReleaseTable from './ReleaseTable'

export default {
  name: 'ReleaseIndex',
  components: {
    ReleaseTable,
    HeaderBar,
    ConfirmDialog,
  },
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  data() {
    return {
      draftPagination: {},
      pendingPagination: {},
      publishedPagination: {},
      unPublishedPagination: {},
      deleteReleaseShown: false,
      deleteId: '',
      deleteStatus: '',
      preKeyword: '',
      keyword: '',
    }
  },
  computed: {
    // 作成中 に表示するステータス
    draftReleaseStatuses() {
      return [
        CMAP_RELEASE_STATUS_DRAFT, // 下書き 0
      ]
    },
    // 審査差し戻し に表示するステータス
    rejectedReleaseStatuses() {
      return [
        CMAP_RELEASE_STATUS_REJECTED, // 差し戻し(narasu) 2
        CMAP_RELEASE_STATUS_DSP_REJECTED, // 差し戻し(DSP) 4
      ]
    },
    // 審査中 に表示するステータス
    pendingReleaseStatuses() {
      return [
        CMAP_RELEASE_STATUS_IN_REVIEW, // 審査中(narasu) 1
        CMAP_RELEASE_STATUS_PREPARE_REJECTED, // 要差し戻し 15
        CMAP_RELEASE_STATUS_UPLOADING, // 納品中 3
        CMAP_RELEASE_STATUS_REAPPLY, // 再申請(narasu) 8
        CMAP_RELEASE_STATUS_DSP_REAPPLY, // 再申請(DSP) 9
        CMAP_RELEASE_STATUS_PREPARE_RELEASE_REJECTED, // 要却下 16
      ]
    },
    // デリバリ済み に表示するステータス
    publishedReleaseStatuses() {
      return [
        CMAP_RELEASE_STATUS_DSP_IN_REVIEW, // 配信待ち 5
        CMAP_RELEASE_STATUS_PUBLISHED, // 配信中 6
        CMAP_RELEASE_STATUS_EDITING, // 更新中 7
        CMAP_RELEASE_STATUS_EDIT_UPLOADING, // 更新納品中 17
        CMAP_RELEASE_STATUS_APPEND_DSP, // 追加ストア申請 10
      ]
    },
    // 配信停止中 に表示するステータス
    takedownReleaseStatuses() {
      return [
        CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN, // 要配信停止 11
        CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN, // 納品中(テイクダウン) 14
        CMAP_RELEASE_STATUS_TAKE_DOWN, // 配信停止 12
      ]
    },
    // 却下 に表示するステータス
    deletedReleaseStatuses() {
      return [
        CMAP_RELEASE_STATUS_RELEASE_REJECTED, // 却下 13
      ]
    },
  },
  methods: {
    onDeleteReleaseClicked(list) {
      this.deleteId = list.id
      this.deleteStatus = list.status
      this.deleteReleaseShown = true
    },
    async onDefaultClicked() {
      const deleteReleaseId = this.deleteId
      const deleteReleaseStatus = this.deleteStatus
      await window.axios.delete(`/api/client/products/${deleteReleaseId}`)
      this.deleteReleaseShown = false

      if (deleteReleaseStatus === 0) { // 作成中
        this.$refs.draftTable.fetchItems()
        this.$refs.rejectTable.fetchItems()
      } else if (deleteReleaseStatus === -1) { // 配信停止中
        this.$refs.pendingTable.fetchItems()
      } else if (deleteReleaseStatus === 1) { // リリース一覧
        this.$refs.publishedTable.fetchItems()
      } else {
        this.$refs.unPublishedTable.fetchItems()
      }
    },
    async onEditReleaseClicked(release) {
      const { data } = await window.axios.get(`/api/client/products/${release.id}/release`)
      window.sessionStorage.setItem('album', JSON.stringify(data))
      window.sessionStorage.removeItem('hasLyricsError')
      window.sessionStorage.removeItem('lyricsCompletePercentage')
      const lyricsErrors = {}
      const lyricsCompletePercentages = {}
      data.discs.forEach((disc, discIndex) => {
        disc.tracks.forEach(track => {
          if (track.lyrics_type !== 2) { return }
          const trackIndex = track.track_index
          if (track.lyrics) {
            const lyricObj = JSON.parse(track.lyrics.lyrics)
            let lyricLength = lyricObj.lines.length
            let counter = 0
            lyricObj.lines.forEach(line => {
              if (line.start === null) {
                counter += 1
              }
            })
            if (lyricLength > 0 && lyricObj.lines[lyricLength - 1].words[0].str != null && lyricObj.lines[lyricLength - 1].words[0].str !== '') {
              lyricLength += 1
              counter += 1
            }
            if (counter > 0) {
              const lyricsCompletePercentage = Math.floor(
                (1 - counter / lyricLength) * 100,
              )
              lyricsErrors[`${discIndex}-${trackIndex}`] = true
              lyricsCompletePercentages[`${discIndex}-${trackIndex}`] = lyricsCompletePercentage
            } else {
              lyricsErrors[`${discIndex}-${trackIndex}`] = false
            }
          }
        })
      })
      if (lyricsCompletePercentages !== {}) {
        window.sessionStorage.setItem('hasLyricsError', JSON.stringify(lyricsErrors))
        window.sessionStorage.setItem('lyricsCompletePercentage', JSON.stringify(lyricsCompletePercentages))
      }
      window.sessionStorage.removeItem('submitReleaseForm')
      window.sessionStorage.setItem('vocaloids', JSON.stringify(data.vocaloid))
      if (release.status === 0) {
        this.$router.push({ name: `release-${data.type === 'single' ? 'single' : 'album'}-step2` })
      } else {
        this.$router.push({ name: 'release-detail' })
      }
    },
    scrollTo(elementName) {
      this.$refs[elementName].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
    onClickedSearch() {
      this.keyword = this.preKeyword
    },
    onEditLinkClicked(release) {
      this.$router.push({ name: 'link-create', params: { id: release.id } })
    },
    onShowLinkClicked(release) {
      window.open(release.product_link.url_full, '_blank')
    },
    isProductLinkDataExists(release) {
      return release.product_link != null && (release.product_link?.status ?? 0) === 1
    },
  },
}
</script>
